/* =============================================
   JOURNEY — Custom Section Scripts
   ============================================= */

// Hero Slider Functionality
let currentSlide = 0;

function moveSlide(direction) {
    const track = document.getElementById('sliderTrack');
    const slides = document.querySelectorAll('.header-slide');
    const dots = document.querySelectorAll('.dot');
    
    if (!track || slides.length === 0) return;
    
    currentSlide = (currentSlide + direction + slides.length) % slides.length;
    updateSlider();
}

function goToSlide(index) {
    currentSlide = index;
    updateSlider();
}

function updateSlider() {
    const track = document.getElementById('sliderTrack');
    const dots = document.querySelectorAll('.dot');
    
    if (!track) return;
    
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    
    // Update dots
    dots.forEach((dot, index) => {
        if (index === currentSlide) {
            dot.classList.add('active');
        } else {
            dot.classList.remove('active');
        }
    });
}

// Parallax Effect for Cafe Hero (FlavCity-style)
function initCafeParallaxes() {
    const sections = document.querySelectorAll('[data-section-type="cafe-parallax"]');
    
    sections.forEach(hero => {
        const container = hero.querySelector('[data-beans-container]');
        const parallaxLeft = hero.querySelector('[data-parallax-item="left"]');
        const parallaxRight = hero.querySelector('[data-parallax-item="right"]');
        const heroCenter = hero.querySelector('[data-parallax-item="center"]');
        const topBeans = hero.querySelector('[data-parallax-item="top-beans"]');
        const bottomBeans = hero.querySelector('[data-parallax-item="bottom-beans"]');

        // 1. Generate Scattered Coffee Beans if not already there
        if (container && container.children.length === 0) {
            const beanCount = parseInt(container.dataset.beanCount) || 45;
            for (let i = 0; i < beanCount; i++) {
                const bean = document.createElement('div');
                bean.className = 'floating-bean';
                
                const size = 15 + Math.random() * 30;
                const x = Math.random() * 100;
                const y = Math.random() * 100;
                const rotate = Math.random() * 360;
                const speed = 0.05 + Math.random() * 0.3;

                bean.style.setProperty('--bean-size', size + 'px');
                bean.style.setProperty('--bean-rotate', rotate + 'deg');
                bean.style.left = x + '%';
                bean.style.top = y + '%';
                bean.style.opacity = 0.5 + Math.random() * 0.5;
                bean.dataset.speed = speed;
                
                if (Math.random() > 0.7) {
                    bean.style.filter = `blur(${Math.random() * 2}px) drop-shadow(0 4px 8px rgba(0,0,0,0.2))`;
                }

                container.appendChild(bean);
            }
        }

        // 2. Parallax Update Logic
        let ticking = false;
        const allBeans = hero.querySelectorAll('.floating-bean');

        function updateParallax() {
            const scrollY = window.scrollY;
            const heroRect = hero.getBoundingClientRect();
            const heroTop = heroRect.top + scrollY;
            const heroH = hero.offsetHeight;
            
            // Only update if section is somewhat visible
            if (scrollY + window.innerHeight < heroTop - 100 || scrollY > heroTop + heroH + 100) return;

            const relativeScroll = scrollY - heroTop;
            const progress = Math.min(Math.max(relativeScroll / heroH, 0), 1);

            // Side Images
            if (parallaxLeft) {
                const yMove = relativeScroll * 0.15;
                parallaxLeft.style.transform = `translateY(${-yMove}px) rotate(${relativeScroll * 0.02}deg)`;
            }
            if (parallaxRight) {
                const yMove = relativeScroll * 0.2;
                parallaxRight.style.transform = `translateY(${-yMove}px) rotate(${-relativeScroll * 0.02}deg)`;
            }

            // Center Content
            if (heroCenter) {
                const yOffset = relativeScroll * 0.3;
                const opacity = 1 - progress * 1.5;
                heroCenter.style.transform = `translateY(${-yOffset}px)`;
                heroCenter.style.opacity = Math.max(opacity, 0);
            }

            // Top & Bottom Bean Piles — clamp movement so they never escape the hero
            if (topBeans) {
                // moves down slightly as user scrolls; clamp to max 60px so it stays inside
                const topMove = Math.min(relativeScroll * 0.18, 60);
                topBeans.style.transform = `translateY(${topMove}px)`;
            }
            if (bottomBeans) {
                // moves up slightly; clamp so it doesn't cover the wave/next section
                const botMove = Math.max(-relativeScroll * 0.06, -40);
                bottomBeans.style.transform = `translateY(${botMove}px)`;
            }

            // Scattered Beans
            allBeans.forEach(bean => {
                const speed = parseFloat(bean.dataset.speed) || 0.2;
                const currentRotate = bean.style.getPropertyValue('--bean-rotate') || '0deg';
                bean.style.transform = `rotate(${currentRotate}) translateY(${relativeScroll * speed}px)`;
            });

            ticking = false;
        }

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(updateParallax);
                ticking = true;
            }
        });

        // Initial run
        updateParallax();
    });
}

// Initialize on Load
document.addEventListener('DOMContentLoaded', () => {
    // Slider
    if (document.getElementById('sliderTrack')) {
        updateSlider();
        setInterval(() => moveSlide(1), 5000);
    }

    // Parallax
    initCafeParallaxes();
});

// Also re-init if the section is loaded in Shopify Theme Editor
if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        if (event.detail.sectionId.includes('hero-cafe')) {
            initCafeParallaxes();
        }
    });
}

